import React, { useEffect, useRef, useState } from 'react';
import { Link } from "react-router-dom";
import Select from "react-select";
import { Button, Badge, Tooltip, OverlayTrigger, Dropdown, Row, Col, Tab, Nav } from "react-bootstrap";
import Drawer from '@mui/material/Drawer';
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import DatePicker, { DateObject } from "react-multi-date-picker";
import new_gif from '../../../images/new_subs.gif';

import csv_ico from '../../../images/export_icons/csv.ico';
import excel_ico from '../../../images/export_icons/excel.ico';
import print_ico from '../../../images/export_icons/print.ico';

import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';

import axios from 'axios';
import * as XLSX from 'xlsx';
import Papa from 'papaparse';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import LoadingComponent from '../../layouts/nav/loading';

const getStartOfWeek = (date) => {
    const day = date.getDay(), // get the current day of the week
        diff = date.getDate() - day; // calculate the difference in days to the previous Sunday
    const startOfWeek = new Date(date.setDate(diff));
    startOfWeek.setHours(0, 0, 0, 0); // set to midnight
    return startOfWeek;
};

const getEndOfWeek = (date) => {
    const day = date.getDay(),
        diff = date.getDate() + (6 - day); // calculate the difference to the next Saturday
    const endOfWeek = new Date(date.setDate(diff));
    endOfWeek.setHours(23, 59, 59, 999); // set to the end of the day
    return endOfWeek;
};

const Payments = () => {
    const branch_id = parseInt(localStorage.getItem("branch_id"), 10);

    const defaultPermissions = {
        view_dashboard: 0,
        branch_man: 0,
       
        lead_man: 0,
        man_lead: 0,
        lead_list: 0,
        lead_add: 0,
        lead_edit: 0,
        lead_followup: 0,
        lead_view: 0,
        lead_import: 0,
        lead_export: 0,
        lead_subscribe: 0,
        man_coupon: 0,
        coupon_list: 0,
        coupon_add: 0,
        coupon_edit: 0,
        coupon_view: 0,
        subscri_man: 0,
        subscriber_list: 0,
        subscriber_view: 0,
        subscriber_edit: 0,
        subscriber_filter: 0,
        subscriber_new_subscription: 0,
        subs_man: 0,
        subscription_list: 0,
        subscription_view: 0,
        subscription_edit: 0,
        subscription_export: 0,
        subscription_hold: 0,
        subscription_complaints: 0,
        subscription_renewal: 0,
        pay_man: 0,
        payment_export: 0,
        payment_list: 0,
        
    };

    // Immediately load from localStorage if available
    const initialPermissions = (() => {
        const stored = localStorage.getItem('user_permissions');
        return stored ? JSON.parse(stored) : defaultPermissions;
    })();

    const [permissions, setPermissions] = useState(initialPermissions);
    const [currentDate, setCurrentDate] = useState(new Date());


    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const imgBaseUrl = process.env.REACT_APP_IMG_BASE_URL;
    const [loading, setLoading] = useState(false);

    const [datas, setData] = useState([]);
    const [hasFetched, setHasFetched] = useState(false);
    const [totalPaymenttable, settotalPaytable] = useState('0');
    const [totalPayment, setTotalPayment] = useState('0');

    // pagination
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const [perPage, setPerPage] = useState(25);

    // page table data fetch
    const fetchData = (filter = {}) => {
        setLoading(true);
        const month = currentDate.getMonth() + 1;  // JS months are 0-based
        const year = currentDate.getFullYear();
        const params = {
            ...filter,      // spread existing filter key-values
            page,           // add page number
            per_page: perPage, // add per_page
            search: searchTerm,
            month,
            year,
            branch_id: branch_id
        };
        axios.get(`${baseURL}/subscription`, { params: params })
            .then(response => {
                setData(response.data.data);
                setHasFetched(true);
                setTotalPages(response.data.last_page);
                settotalPaytable(response.data.total_amount_sum);
                setTotalPayment(response.data.total_payment);
                setLoading(false);
            })
            .catch(error => {
                console.log('There was an error fetching the data!', error);
                setHasFetched(true);
                setLoading(false);
            });
    };

    useEffect(() => {
        fetchData();
    }, [page, searchTerm, perPage, currentDate]);

    const tableRef = useRef(null);

    // ------------------------------------------------------------ Filter Section -----------------------------------------

    // subs option & on select
    const [filter_subs_id, setFilterSubsID] = useState(null);
    const [subsribersOpt, setSubscribersOpt] = useState([]);
    useEffect(() => {
        axios.get(`${baseURL}/leadsubscription/subscribers`)
            .then(response => {
                const formatted = response.data.data.map(item => ({
                    value: item.lead,
                    label: item.lead_name,
                }));
                const allOption = { value: null, label: "All" };
                setSubscribersOpt([allOption, ...formatted]);
            })
            .catch(error => {
                console.error('There was an error fetching the data!', error);
            });
    }, []);

    // prods option & on select
    const [filter_prods_id, setFilterProdsID] = useState(null);
    const [productsOpt, setProductsOpt] = useState([]);
    useEffect(() => {
        axios.get(`${baseURL}/manage-products/products/active`)
            .then(response => {
                const formatted = response.data.data.map(item => ({
                    value: item.sno,
                    label: item.product_name,
                }));
                const allOption = { value: null, label: "All" };
                setProductsOpt([allOption, ...formatted]);
            })
            .catch(error => {
                console.error('There was an error fetching the data!', error);
            });
    }, []);

    // timeline option & on select
    const [filter_tline_id, setFilterTlineID] = useState(null);
    const [timelineoptions, setTimelineoption] = useState([]);
    useEffect(() => {
        axios.get(`${baseURL}/package-timeline/active`)
            .then(response => {
                const formatted = response.data.data.map(item => ({
                    value: item.sno,
                    label: item.packagetimeline_name,
                }));
                const allOption = { value: null, label: "All" };
                setTimelineoption([allOption, ...formatted]);
            })
            .catch(error => {
                console.error('There was an error fetching the data!', error);
            });
    }, []);


    // Paymode
    const [filter_pmode_id, setFilterPmodeID] = useState(null);
    // const [pmodeoptions, setPmodeoption] = useState([]);
    const pymodeopt = [
        { value: null, label: "All" },
        { value: 1, label: "Offline" },
        { value: 2, label: "Online" }
    ];
    // useEffect(() => {
    //     axios.get(`${baseURL}/paymentmode/getactive`)
    //         .then(response => {
    //             const formatted = response.data.map(item => ({
    //                 value: item.sno,
    //                 label: item.paymentmode_name,
    //             }));
    //             const allOption = { value: null, label: "All" };
    //             setPmodeoption([allOption, ...formatted]);
    //         })
    //         .catch(error => {
    //             console.error('There was an error fetching the data!', error);
    //         });
    // }, []);

    const [filterOpen, setFilterOpen] = useState(false);


    const onClose = () => {
        setFilterOpen(false);
    };

    const [filtermob_no, setFilterMob] = useState('');
    const [date_fil_selt_value, setDateFilSeltValue] = useState("all");
    const [today_fil_value, setTodayFilValue] = useState(new Date());
    const [week_stdt_fil_value, setWeekSTDTFilValue] = useState(getStartOfWeek(new Date()));
    const [week_eddt_fil_value, setWeekEDDTFilValue] = useState(getEndOfWeek(new Date()));
    const [month_fil_value, setMonthFilValue] = useState(new Date());
    const [custom_stdt_fil_value, setCustomSTDTFilValue] = useState(new Date());
    const [custom_eddt_fil_value, setCustomEDDTFilValue] = useState(new Date());

    const date_fil_options = [
        { value: "all", label: "All" },
        { value: "today", label: "Today" },
        { value: "this_week", label: "This week" },
        { value: "this_month", label: "This Month" },
        { value: "custom", label: "Custom Date" }
    ];

    const [filter_pysts, setFilterPysta] = useState(null);
    const paystatus = [
        { value: null, label: "All" },
        { value: 0, label: "Paid" },
        { value: 1, label: "Pending" }
    ];

    const handleGoClick = () => {

        const filter = {
            lead: filter_subs_id || '',
            product: filter_prods_id || '',
            timeline: filter_tline_id || '',
            lead_mobile_no: filtermob_no || '',
            payment_mode: filter_pmode_id || '',
            payment_process: filter_pysts,
            date_filter: date_fil_selt_value || '',
        };
        if (date_fil_selt_value === 'custom') {
            filter.start_date = custom_stdt_fil_value || '';
            filter.end_date = custom_eddt_fil_value || '';
        }
        setHasFetched(false);
        if ($.fn.dataTable.isDataTable(tableRef.current)) {
            $(tableRef.current).DataTable().destroy();
        }
        fetchData(filter);
        onClose();
    };

    // ---------------------------------------------------- End Filter -------------------------------


    useEffect(() => {
        if (hasFetched) {
            if (tableRef.current) {
                if (!$.fn.dataTable.isDataTable(tableRef.current)) {
                    $(tableRef.current).DataTable({
                        "responsive": true,
                        //   "aaSorting": [],
                        pageLength: 25,
                        "ordering": false,
                        "language": {
                            "lengthMenu": "Show&nbsp;&nbsp; _MENU_",
                        },
                        "dom":
                            "<'row'" +
                            "<'col-sm-6 d-flex align-items-center justify-content-start mb-2'l>" +
                            "<'col-sm-6 d-flex align-items-center justify-content-end mb-2'f>" +
                            ">" +
                            "<'table-responsive'tr>" +
                            "<'row'" +
                            "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>" +
                            "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2'p>" +
                            ">"
                    });
                }
            }
        }
    }, [hasFetched]);


    // -------------------------------------------------- export -----------------------------------//

    const exportCSV = async () => {
        try {
            const month = currentDate.getMonth() + 1;  // JS months are 0-based
            const year = currentDate.getFullYear();
            const filter = {
                lead: filter_subs_id || '',
                product: filter_prods_id || '',
                timeline: filter_tline_id || '',
                lead_mobile_no: filtermob_no || '',
                payment_mode: filter_pmode_id || '',
                payment_process: filter_pysts,
                date_filter: date_fil_selt_value || '',
            };
            if (date_fil_selt_value === 'custom') {
                filter.start_date = custom_stdt_fil_value || '';
                filter.end_date = custom_eddt_fil_value || '';
            }
            const params = {
                ...filter,
                search: searchTerm,
                per_page: 'all',
                branch_id: branch_id,
                month,
                year,
            };

            const response = await axios.get(`${baseURL}/subscription`, { params });
            const allData = response.data.data;

            const columnNames = [
                'S.No', 'Subscriber Name', 'Mobile No',
                'Payment Mode', 'Product Count',  'GST Amount', 'Total Amount', 'Payment Status'
            ];
            const formattedData = allData.map((item, index) => ({
                'S.No': index + 1,
                'Subscriber Name': item.subscriber_name,
                'Mobile No': item.subscriber_mobile_no,
                'Payment Mode': item.payment_mode_name || '-',
                'Product Count': item.product_count || 1,
                'GST Amount': item.gst_amount || 0,
                'Total Amount': item.total_amount || 0,
                'Payment Status': item.payment_process === 0 ? 'Paid' : 'Pending'
            }));
            const csv = Papa.unparse({
                fields: columnNames,
                data: formattedData
            });
            const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = 'payment.csv';
            link.click();
        } catch (error) {
            console.error('Export failed:', error);
            toast.error("Export Faild");
        }
    };

    const exportExcel = async () => {
        try {
            const month = currentDate.getMonth() + 1;  // JS months are 0-based
            const year = currentDate.getFullYear();
            const filter = {
                lead: filter_subs_id || '',
                product: filter_prods_id || '',
                timeline: filter_tline_id || '',
                lead_mobile_no: filtermob_no || '',
                payment_mode: filter_pmode_id || '',
                payment_process: filter_pysts,
                date_filter: date_fil_selt_value || '',
            };
            if (date_fil_selt_value === 'custom') {
                filter.start_date = custom_stdt_fil_value || '';
                filter.end_date = custom_eddt_fil_value || '';
            }
            const params = {
                ...filter,
                search: searchTerm,
                per_page: 'all',
                branch_id: branch_id,
                month,
                year,
            };

            const response = await axios.get(`${baseURL}/subscription`, { params });
            const allData = response.data.data;

            const columnNames = [
                'S.No', 'Subscriber Name', 'Mobile No',
                'Payment Mode', 'Product Count',  'GST Amount', 'Total Amount', 'Payment Status'
            ];
            const formattedData = allData.map((item, index) => ({
                'S.No': index + 1,
                'Subscriber Name': item.subscriber_name,
                'Mobile No': item.subscriber_mobile_no,
                'Payment Mode': item.payment_mode_name || '-',
                'Product Count': item.product_count || 1,
                'GST Amount': item.gst_amount || 0,
                'Total Amount': item.total_amount || 0,
                'Payment Status': item.payment_process === 0 ? 'Paid' : 'Pending'
            }));

            // Create worksheet from formatted data
            const ws = XLSX.utils.json_to_sheet(formattedData);

            // Create a new workbook and append the worksheet
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

            // Write the workbook to an Excel file and trigger the download
            XLSX.writeFile(wb, 'payment.xlsx');
        } catch (error) {
            console.error('Export failed:', error);
            toast.error("Export Faild");
        }
    };

    const print = async () => {
        try {
            const month = currentDate.getMonth() + 1;  // JS months are 0-based
            const year = currentDate.getFullYear();
            const filter = {
                lead: filter_subs_id || '',
                product: filter_prods_id || '',
                timeline: filter_tline_id || '',
                lead_mobile_no: filtermob_no || '',
                payment_mode: filter_pmode_id || '',
                payment_process: filter_pysts,
                date_filter: date_fil_selt_value || '',
            };
            if (date_fil_selt_value === 'custom') {
                filter.start_date = custom_stdt_fil_value || '';
                filter.end_date = custom_eddt_fil_value || '';
            }
            const params = {
                ...filter,
                search: searchTerm,
                per_page: 'all',
                branch_id: branch_id,
                month,
                year,
            };

            const response = await axios.get(`${baseURL}/subscription`, { params });
            const allData = response.data.data;

            const columnNames = [
                'S.No', 'Subscriber Name', 'Mobile No',
                'Payment Mode', 'Product Count', 'GST Amount', 'Total Amount', 'Payment Status'
            ];
            const formattedData = allData.map((item, index) => ({
                'S.No': index + 1,
                'Subscriber Name': item.subscriber_name,
                'Mobile No': item.subscriber_mobile_no,
                'Payment Mode': item.payment_mode_name || '-',
                'Product Count': item.product_count || 1,
                'GST Amount': item.gst_amount || 0,
                'Total Amount': item.total_amount || 0,
                'Payment Status': item.payment_process === 0 ? 'Paid' : 'Pending'
            }));

            // Create an HTML table for printing
            let printContent = `<table style="width: 100%; border-collapse: collapse; border: 1px solid #ddd;">
                <thead>
                    <tr style="background-color: #f2f2f2;">`;

            // Add column headers
            columnNames.forEach(col => {
                printContent += `<th style="padding: 8px; text-align: left; border: 1px solid #ddd;">${col}</th>`;
            });

            printContent += `</tr></thead><tbody>`;

            // Add the rows of data
            formattedData.forEach(row => {
                printContent += `<tr>`;
                columnNames.forEach(col => {
                    printContent += `<td style="padding: 8px; border: 1px solid #ddd;">${row[col]}</td>`;
                });
                printContent += `</tr>`;
            });

            printContent += `</tbody></table>`;

            // Open the print dialog
            const printWindow = window.open('', '', 'height=800,width=1000');
            printWindow.document.write('<html><head><title>Subscription Details</title>');
            printWindow.document.write('<style>table { width: 100%; border-collapse: collapse; }</style>');
            printWindow.document.write('</head><body>');
            printWindow.document.write(printContent);
            printWindow.document.write('</body></html>');
            printWindow.document.close(); // Necessary for IE >= 10
            printWindow.print();
        } catch (error) {
            console.error('Export failed:', error);
            toast.error("Export Faild");
        }
    };

    // ------------------------------------------- Formats ----------------------

    const formatDate = (date) => {
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, '0');
        const month = months[d.getMonth()];
        const year = d.getFullYear();
        return `${day}-${month}-${year}`;
    };

    function formatTime(timeStr) {
        if (timeStr) {
            const [hours, minutes] = timeStr.split(':');
            const date = new Date();
            date.setHours(parseInt(hours));
            date.setMinutes(parseInt(minutes));
            return date
                .toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true })
                .toUpperCase();  // Force AM/PM to uppercase
        } else {
            return '';
        }
    }

    const checkdate = (date) => {
        const isToday = new Date(date).toDateString() === new Date().toDateString();
        return isToday;
    }

    // soft refresh
    const softRefresh = () => {
        setHasFetched(false);
        if ($.fn.dataTable.isDataTable(tableRef.current)) {
            $(tableRef.current).DataTable().destroy();
        }
        fetchData();
    }

    const formatMonthYear = (date) => {
        return date.toLocaleString('default', { month: 'long', year: 'numeric' });
    };

    const handlePreviousMonth = () => {
        const prevMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1);
        setCurrentDate(prevMonth);
        // Call your fetch function here, e.g., fetchDataForMonth(prevMonth)
    };

    const handleNextMonth = () => {
        const today = new Date();
        const nextMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1);

        // Disable if nextMonth is after current month/year
        if (
            nextMonth.getFullYear() < today.getFullYear() ||
            (nextMonth.getFullYear() === today.getFullYear() && nextMonth.getMonth() <= today.getMonth())
        ) {
            setCurrentDate(nextMonth);
            // fetchDataForMonth(nextMonth); // if needed
        }
    };

    const [key, setKey] = useState('subscription');

    const [isMaintenance, setIsMaintenance] = useState(false);

    useEffect(() => {
        let isMounted = true;

        const checkMaintenanceStatus = async () => {
            try {
                const response = await axios.get(`${baseURL}/maintenance-mode?branch_id=${branch_id}`);
                const data = response.data.data || [];
                const branchStatus = data.find((item) => item.slug === "payments-management"); // use managebranch slug

                if (isMounted) {
                    setIsMaintenance(branchStatus?.maintenancemode_status === 1);
                }
            } catch (error) {
                console.error("Error checking maintenance mode:", error);
                if (isMounted) setIsMaintenance(false);
            } finally {
                if (isMounted) setLoading(false);
            }
        };

        checkMaintenanceStatus();

        return () => {
            isMounted = false;
        };
    }, [baseURL, branch_id]);

    if (loading) {
        return <div>Loading...</div>; // optional loading state
    }

    if (isMaintenance) {
        return (
            <div
                className="d-flex flex-column align-items-center justify-content-center text-center"
                style={{ height: "100vh", width: "100vw" }}
            >
                <h1 className="text-warning mb-3">🚧 Under Maintenance</h1>
                <p className="text-muted fs-5">
                    The <strong>Manage Payment Management </strong> module is currently under maintenance. <br />
                    Please check back later.
                </p>
            </div>
        );
    }

    return (
        <>
            <div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mx-0">
                <div className='mb-0'>
                    <div className="mb-0 px-0">
                        <h4 style={{ color: '#025d3a' }}>Manage Payment</h4>
                    </div>
                    <ol className="breadcrumb fs-7">
                        <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
                        <li className="breadcrumb-item"><i className="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item active">Payment Management</li>
                    </ol>
                </div>

                {permissions.payment_list === 1 && (
                    <div className='d-flex align-items-center gap-3'>
                        <Link to={"#"} className="btn btn-primary float-end btn-sm" onClick={() => setFilterOpen(true)}>
                            <span className='me-2'><i className="fa-solid fa-filter fs-8"></i></span>
                            <span className=''>Filter</span>
                        </Link>
                        {permissions.payment_export === 1 && (
                            <Dropdown>
                                <Dropdown.Toggle
                                    as="button"
                                    variant="primary"
                                    className="btn btn-primary text-white btn-sm"
                                    id="tp-btn"
                                >
                                    <span className='me-2'><i className="fa-solid fa-circle-down fs-8"></i></span>
                                    <span className=''>Export</span>
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    {/* <Dropdown.Item onClick={exportCSV} className='px-2'> */}
                                    <Dropdown.Item onClick={exportCSV} className='px-2'>
                                        <img
                                            src={csv_ico}
                                            alt="CSV"
                                            className='w-30px h-30px'
                                        />
                                        <span className='fs-7 ms-2 font-w500 text-black'>CSV</span>
                                    </Dropdown.Item>
                                    {/* <Dropdown.Item onClick={exportExcel} className='px-2'> */}
                                    <Dropdown.Item onClick={exportExcel} className='px-2'>
                                        <img
                                            src={excel_ico}
                                            alt="Excel"
                                            className='w-30px h-30px'
                                        />
                                        <span className='fs-7 ms-2 font-w500 text-black'>Excel</span>
                                    </Dropdown.Item>
                                    <Dropdown.Item onClick={print} className='px-2'>
                                        {/* <Dropdown.Item className='px-2'> */}
                                        <img
                                            src={print_ico}
                                            alt="Print"
                                            className='w-30px h-30px'
                                        />
                                        <span className='fs-7 ms-2 font-w500 text-black'>Print</span>
                                    </Dropdown.Item>

                                </Dropdown.Menu>
                            </Dropdown>
                        )}
                    </div>
                )}
            </div>

            <LoadingComponent loading={loading} />

            <Col xl={12} className='mb-3'>
                <div className="custom-tab-1">
                    <Tab.Container activeKey={key} onSelect={(k) => setKey(k)}>
                        <Nav as="ul" className="nav-tabs">
                            <Nav.Item as="li" >
                                <Nav.Link eventKey="subscription">
                                    <i class="fa-solid fa-user-tie"></i>
                                    <label className="ms-2 fs-6">
                                        Subscription
                                    </label>
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item as="li" >
                                <Nav.Link as={Link} to="/payments-management-catering">
                                    <i class="fa-solid fa-layer-group"></i>
                                    <label className="ms-2 fs-6">
                                        Catering
                                    </label>
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item as="li" >
                                <Nav.Link as={Link} to="/payments-management-corporate">
                                    <i class="fa-solid fa-hotel"></i>
                                    <label className="ms-2 fs-6">
                                        Corporate
                                    </label>
                                </Nav.Link>
                            </Nav.Item>
                        </Nav>
                    </Tab.Container>
                </div>
            </Col>

            {permissions.payment_list === 1 && (
                <>
                    <div className="row mb-3">
                        <div className="d-flex justify-content-between w-100">
                            {/* LEFT: Month filter */}
                            <div className='col-md-6 d-flex align-items-center'>
                                <div className="d-flex align-items-center">
                                    <button className="btn btn-sm  me-2" onClick={handlePreviousMonth}>
                                        <i className="fa-solid fa-chevron-left fs-4"></i>
                                    </button>
                                    <span className="fw-bold fs-3 text-red">{formatMonthYear(currentDate)}</span>
                                    <button className="btn btn-sm  ms-2" onClick={handleNextMonth} disabled={new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1) > new Date(new Date().getFullYear(), new Date().getMonth(), 1)}>
                                        <i className="fa-solid fa-chevron-right fs-4"></i>
                                    </button>
                                </div>
                            </div>

                            {/* RIGHT: Total Payment */}
                            <div className='d-flex align-items-end justify-content-end'>
                                <div className='me-2'>
                                    <div className='border rounded px-3 py-1 border-success bg-success-light'>
                                        <label className='text-black fs-6'>Total Payment ( {currentDate.toLocaleString('default', { month: 'long' })} )</label>
                                        <div className='d-block text-center'>
                                            <label className="text-danger fs-3 m-0 fw-bold">
                                                <span><i className="fa-solid fa-indian-rupee-sign me-1"></i></span>
                                                <span>{totalPayment}</span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                    <div className="table-container">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            {/* Left: Show entries dropdown */}
                            <div>
                                <label className="me-2">Show</label>
                                <select
                                    className="form-select d-inline w-auto"
                                    style={{ fontSize: '0.85rem', height: '30px' }}
                                    value={perPage}
                                    onChange={(e) => {
                                        setPerPage(Number(e.target.value));
                                        setPage(1); // Reset to first page
                                    }}
                                >
                                    <option value={10}>10</option>
                                    <option value={25}>25</option>
                                    <option value={50}>50</option>
                                    <option value={100}>100</option>
                                </select>
                            </div>

                            {/* Right: Search input */}
                            <div>
                                <input
                                    type="text"
                                    style={{ fontSize: '0.85rem', height: '40px' }}
                                    placeholder="Search..."
                                    className="form-control"
                                    value={searchTerm}
                                    onChange={(e) => {
                                        setSearchTerm(e.target.value);
                                        setPage(1); // Reset page on new search
                                    }}
                                />
                            </div>
                        </div>

                        <table className="table align-top table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable" style={{ borderBottom: '2px solid #ddd' }}>
                            <thead>
                                <tr className=" text-start text-muted fw-bold fs-6 gs-0 th_head">
                                    <th className='min-w-80px'>Date / Time</th>
                                    <th className='min-w-100px'>Subscribers</th>
                                    <th className='min-w-100px text-center'>Payment Mode</th>
                                    {/* <th className='min-w-100px text-center'>Product Count</th> */}
                                    {/* <th className='min-w-100px'>Sub Amount</th> */}
                                    {/* <th className='min-w-100px'>Discount Amount</th> */}
                                    <th className='min-w-100px'>GST Amount</th>
                                    <th className='min-w-100px'>Total Amount</th>
                                    <th className='min-w-100px text-center'>Payment Status</th>
                                </tr>
                            </thead>
                            <tbody className="text-gray-600 fw-semibold fs-7">
                                {datas.length === 0 && hasFetched ? (
                                    <tr>
                                        <td colSpan="7" className="text-center text-muted py-2">
                                            No data available
                                        </td>
                                    </tr>
                                ) : (
                                    <>
                                        {datas.map((data, index) => (
                                            <tr key={data.sno}>
                                                <td>
                                                    {data.payment_process !== 1 ? (
                                                        <>
                                                            <label className='text-black font-w400 fs-7'>{formatDate(data.created_at)}</label>
                                                            <div className='d-block'>
                                                                <label className='text-dark font-w600 fs-8'>{formatTime(data.created_at)}</label>
                                                            </div>
                                                        </>
                                                    ) : (
                                                        '-'
                                                    )}
                                                </td>
                                                <td>
                                                    <div className='d-flex flex-wrap'>
                                                        <label className='text-black font-w400 fs-7 me-2'>{data.subscriber_name}</label>
                                                        {checkdate(data.created_at) && (
                                                            <img src={new_gif} alt="Break Box" className='w-50px h-20px' />
                                                        )}
                                                    </div>
                                                    <div className='d-block'>
                                                        <label className='text-dark font-w600 fs-8'>{data.subscriber_mobile_no}</label>
                                                    </div>
                                                </td>
                                                <td className='text-center'>
                                                    {data.payment_process !== 1 ? (
                                                        <>
                                                            <label className='text-black font-w400 fs-7'>{data.payment_mode_name}</label>
                                                            {data.transaction_id && (
                                                                <div className='d-block'>
                                                                    <label className='text-dark font-w600 fs-8'>{data.transaction_id}</label>
                                                                </div>
                                                            )}
                                                        </>
                                                    ) : (
                                                        '-'
                                                    )}
                                                </td>
                                                <td style={{ textAlign: 'right' }}>
                                                    <label className='text-info fw-bold fs-7'>
                                                        <span><i className="fa-solid fa-indian-rupee-sign me-2"></i></span>
                                                        <span>{data.gst_amount}</span>
                                                    </label>
                                                </td>
                                                <td style={{ textAlign: 'right' }}>
                                                    <label className='text-danger fw-bold fs-7'>
                                                        <span><i className="fa-solid fa-indian-rupee-sign me-2"></i></span>
                                                        <span>{data.total_amount}</span>
                                                    </label>
                                                </td>
                                                <td className='text-center'>
                                                    {data.payment_process !== 1 ? (
                                                        <>
                                                            <span className="text-white fs-7 py-0 px-1 badge bg-success">Paid</span>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <span className="text-white fs-7 py-0 px-1 badge bg-danger">Pending</span>
                                                        </>
                                                    )}
                                                </td>
                                            </tr>
                                        ))}
                                    </>
                                )}
                            </tbody>
                            <tfoot>
                                <tr>
                                    <td colSpan="5" className='text-end text-black font-w500 fs-3'>Total</td>
                                    <td className='text-end'>
                                        <label className='text-danger fw-bold fs-2'>
                                            <span><i className="fa-solid fa-indian-rupee-sign me-2"></i></span>
                                            <span>{totalPaymenttable}</span>
                                        </label>
                                    </td>
                                </tr>
                            </tfoot>
                        </table>

                        <div className="d-flex justify-content-between align-items-center mt-3">
                            {/* Bottom left: Showing x to y of z entries */}
                            <div>
                                {datas.length > 0 ? (
                                    <span className="text-muted">
                                        Showing {(page - 1) * perPage + 1} to {(page - 1) * perPage + datas.length} of {totalPages * perPage - (perPage - datas.length)} entries
                                    </span>
                                ) : (
                                    <span className="text-muted">
                                        Showing 0 to 0 of 0 entries
                                    </span>
                                )}
                            </div>

                            {/* Bottom right: Pagination */}
                            <nav>
                                <ul className="pagination mb-0" style={{ fontSize: '0.75rem' }}>
                                    <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
                                        <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page - 1)}>Previous</button>
                                    </li>
                                    {[...Array(totalPages)].map((_, i) => (
                                        <li key={i} className={`page-item ${page === i + 1 ? 'active' : ''}`}>
                                            <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(i + 1)}>{i + 1}</button>
                                        </li>
                                    ))}
                                    <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
                                        <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page + 1)}>Next</button>
                                    </li>
                                </ul>
                            </nav>

                        </div>
                    </div>
                </>
            )}

            {permissions.payment_list === 0 && (
                <div className='align-content-center' style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    paddingTop: '10%',
                    // height: '100vh',       // full viewport height
                    color: 'red',          // text-danger equivalent
                    fontSize: '24px',      // increase font size
                    fontWeight: 'bold'     // optional for emphasis
                }}>
                    <label>No Access</label>
                </div>
            )}

            <Drawer
                anchor="right"
                open={filterOpen}
                onClose={() => setFilterOpen(false)}
                disableEscapeKeyDown
                BackdropProps={{
                    onClick: (e) => e.stopPropagation(),
                }}
                sx={{
                    width: 400,
                    flexShrink: 0,
                    '& .MuiDrawer-paper': {
                        width: 400,
                        boxSizing: 'border-box',
                    },
                    '@media (max-width: 375px)': {
                        '& .MuiDrawer-paper': {
                            width: 320,
                        },
                    },
                    '@media (max-width: 320px)': {
                        '& .MuiDrawer-paper': {
                            width: 280,
                        },
                    },
                }}
            >
                <div className='modal-header mb-0 px-4 pt-2 pb-0'>
                    <h5 className='fs-4' style={{ color: '#ea1d25' }}>Payment Filter</h5>
                    <div>
                        <Button variant="" type="button" size='sm' data-dismiss="modal" onClick={onClose}>
                            <span className='fs-2'>×</span>
                        </Button>
                    </div>
                </div>
                <div className='card border-0'>
                    <div className='card-body py-0'>
                        <div className='row mb-2 py-2'>
                            
                            <div className="col-lg-12 mb-2">
                                <label className="text-black font-w500 fs-7">Payment Mode</label>
                                <Select
                                    value={pymodeopt.find(option => option.value === filter_pmode_id) || null}
                                    onChange={(selectedOption) => setFilterPmodeID(selectedOption.value)}
                                    options={pymodeopt}
                                    placeholder="Select Payment mode"
                                />
                            </div>
                            <div className="col-lg-12 mb-2">
                                <label className="text-black font-w500 fs-7">Payment Status</label>
                                <Select
                                    value={paystatus.find(option => option.value === filter_pysts) || null}
                                    onChange={(selectedOption) => setFilterPysta(selectedOption.value)}
                                    options={paystatus}
                                    placeholder="Select Status"
                                />
                            </div>
                            <div className="col-lg-12 mb-2">
                                <label className="text-black font-w500 fs-7">Date</label>
                                <Select
                                    value={date_fil_options.find(option => option.value === date_fil_selt_value)}
                                    onChange={(selectedOption) => setDateFilSeltValue(selectedOption.value)}
                                    options={date_fil_options}
                                    menuPlacement="top"
                                />
                            </div>
                            {date_fil_selt_value === "all" && <></>}
                            {date_fil_selt_value === "today" && (
                                <div className="col-lg-12 mb-2">
                                    <label className="text-black font-w500 fs-7">Today</label>
                                    <div className='datepicker-wrapper d-flex'>
                                        <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                        <DatePicker
                                            value={today_fil_value}
                                            onChange={setTodayFilValue}
                                            format="DD-MM-YYYY"
                                            readOnly={true}
                                        />
                                    </div>
                                </div>
                            )}
                            {date_fil_selt_value === "this_week" && (
                                <>
                                    <div className="col-lg-6 mb-2">
                                        <label className="text-black font-w500 fs-7">Start Date</label>
                                        <div className='datepicker-wrapper d-flex'>
                                            <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                            <DatePicker
                                                value={week_stdt_fil_value}
                                                onChange={setWeekSTDTFilValue}
                                                format="DD-MM-YYYY"
                                                readOnly={true}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-6 mb-2">
                                        <label className="text-black font-w500 fs-7">End Date</label>
                                        <div className='datepicker-wrapper d-flex'>
                                            <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                            <DatePicker
                                                value={week_eddt_fil_value}
                                                onChange={setWeekEDDTFilValue}
                                                format="DD-MM-YYYY"
                                                calendarPosition="top-end"
                                                readOnly={true}
                                            />
                                        </div>
                                    </div>
                                </>
                            )}
                            {date_fil_selt_value === "this_month" && (
                                <div className="col-lg-12 mb-2">
                                    <label className="text-black font-w500 fs-7">This Month</label>
                                    <div className='datepicker-wrapper d-flex'>
                                        <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                        <DatePicker
                                            value={month_fil_value}
                                            onChange={setMonthFilValue}
                                            format="MMM-YYYY"
                                            calendarPosition="top"
                                            mode="single"
                                            onlyMonthPicker={true}
                                            readOnly={true}
                                        />
                                    </div>
                                </div>
                            )}
                            {date_fil_selt_value === "custom" && (
                                <>
                                    <div className="col-lg-6 mb-2">
                                        <label className="text-black font-w500 fs-7">Start Date</label>
                                        <div className='datepicker-wrapper d-flex'>
                                            <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                            <DatePicker
                                                value={custom_stdt_fil_value}
                                                onChange={setCustomSTDTFilValue}
                                                format="DD-MM-YYYY"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-6 mb-2">
                                        <label className="text-black font-w500 fs-7">End Date</label>
                                        <div className='datepicker-wrapper d-flex'>
                                            <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                            <DatePicker
                                                value={custom_eddt_fil_value}
                                                onChange={setCustomEDDTFilValue}
                                                format="DD-MM-YYYY"
                                                calendarPosition="top-end"
                                            />
                                        </div>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-center gap-1">
                        <Button className="me-2 btn-sm" variant="secondary" onClick={() => {
                            setFilterSubsID(null);
                            setFilterProdsID(null);
                            setFilterTlineID(null);
                            setFilterPmodeID(null);
                            setFilterMob('');
                            setDateFilSeltValue('all');
                            setFilterPysta(null);
                            softRefresh();
                            onClose();
                            // window.location.reload();
                        }}>
                            <span className='font-w400'>Reset</span>
                        </Button>
                        <Button className="me-2 btn-sm" variant="primary" onClick={handleGoClick}>
                            <span className='font-w400'>Go</span>
                        </Button>
                    </div>
                </div>
            </Drawer>

        </>
    )


}
export default Payments;